import { baseApi, WITHDRAWALS_TAG, AUTH_TAG } from '@/shared';

import { withdrawalAdapter } from '../utils/helpers/adapter';

import type {
  TGetWithdrawalsParams,
  TWithdrawalResponse,
  TWithdrawalApproveParams,
  TWithdrawalDeclineParams,
  TWithdrawalInProgressParams,
} from './types';

export const withdrawalsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getWithdrawals: build.query<TWithdrawalResponse, TGetWithdrawalsParams>({
      query: (params: TGetWithdrawalsParams) => ({
        url: '/admin/withdrawals/list',
        params: {
          id: params.id,
          created_from: params.createdFrom,
          created_to: params.createdTo,
          amount_from: params.amountFrom,
          amount_to: params.amountTo,
          currency: params.currency,
          shop_id: params.shopId,
          method_id: params.methodId,
          status: params.status,
          page_size: params.pageSize,
          page: params.page,
          ascending: params.ascending,
        },
      }),
      transformResponse: withdrawalAdapter,
      providesTags: [WITHDRAWALS_TAG, AUTH_TAG],
    }),

    getWithdrawalsAwaitingApproval: build.query<number, void>({
      query: () => ({
        url: '/admin/withdrawals/awaiting_approval'
      }),
      providesTags: [WITHDRAWALS_TAG, AUTH_TAG],
    }),

    approveWithdrawal: build.mutation<void, TWithdrawalApproveParams>({
      query: ({ withdrawalId }) => ({
        url: `/admin/withdrawals/approve/${withdrawalId}`,
        method: 'PUT',
      }),
      invalidatesTags: [WITHDRAWALS_TAG],
    }),

    checkWithdrawal: build.mutation<void, { withdrawalId: number }>({
      query: ({ withdrawalId }) => ({
        url: `/admin/withdrawals/check/${withdrawalId}`,
        method: 'PUT',
      }),
      invalidatesTags: [WITHDRAWALS_TAG],
    }),

    declineWithdrawal: build.mutation<void, TWithdrawalDeclineParams>({
      query: ({ withdrawalId }) => ({
        url: `/admin/withdrawals/decline/${withdrawalId}`,
        method: 'PUT',
      }),
      invalidatesTags: [WITHDRAWALS_TAG],
    }),

    inProgressWithdrawal: build.mutation<void, TWithdrawalInProgressParams>({
      query: ({ withdrawalId }) => ({
        url: `/admin/withdrawals/in_progress/${withdrawalId}`,
        method: 'PUT',
      }),
      invalidatesTags: [WITHDRAWALS_TAG],
    }),

  }),
});

export const {
  useGetWithdrawalsQuery,
  useGetWithdrawalsAwaitingApprovalQuery,
  useApproveWithdrawalMutation,
  useCheckWithdrawalMutation,
  useDeclineWithdrawalMutation,
  useInProgressWithdrawalMutation,
} = withdrawalsApi;
